<div class="search-group">
  <i class="fas fa-search"></i>
  <input
    class="form-control"
    #searchInput
    type="text"
    autocomplete="off"
    [placeholder]="placeholder" />
</div>
